import { faBarcode } from '@fortawesome/pro-regular-svg-icons/faBarcode';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import styles from './styles.module.less';
import { BarcodeTypeProperty } from '../../properties-panel/widget-properties/barcode-type/barcode-type';
import { ContentProperty } from '../../properties-panel/widget-properties/content/content';
import { HeightProperty } from '../../properties-panel/widget-properties/height-input/height-input';
import { WidthProperty } from '../../properties-panel/widget-properties/width-input/width-input';
import { WIDGET_TYPE } from '../widget-type';

import type { BarcodeWidget, WidgetProperties, BarcodeWidgetDefinition, WidgetConfig } from '../../config';

const barcodeDefinition: BarcodeWidgetDefinition = {
  type: WIDGET_TYPE.barcode,
  ui: {
    label: 'Barcode',
    pickerElement: <FontAwesomeIcon icon={faBarcode} />,
  },
  initialConfiguration: {
    width: 144,
    height: 60,
    content: '5901234123457',
    barcodeType: 'code128',
  },
};

const barcodeProperties: WidgetProperties<BarcodeWidget> = [WidthProperty, HeightProperty, BarcodeTypeProperty, ContentProperty];

const Barcode = () => {
  return <FontAwesomeIcon className={styles['barcode-icon']} icon={faBarcode} />;
};

export const BarcodeWidgetConfig: WidgetConfig<BarcodeWidget> = {
  Component: Barcode,
  definition: barcodeDefinition,
  properties: barcodeProperties,
};
